import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import Keycloak from 'keycloak-js'
import api from './modules/api'
import VueHtml2Canvas from "vue-html2canvas/src";


Vue.use(VueHtml2Canvas);
api.backendUrl =  window.VUE_APP_MAIN_BACKEND_URL
Vue.prototype.$backendUrl =  window.VUE_APP_MAIN_BACKEND_URL

let initOptions = {
  url:  window.VUE_APP_KEYCLOAK_URL,
  realm:  window.VUE_APP_KEYCLOAK_REALM,
  clientId:  window.VUE_APP_KEYCLOAK_CLIENT_ID,
  onLoad: 'check-sso',
  // onLoad: 'login-required'
}

let keycloak = Keycloak(initOptions)
Vue.prototype.$keycloak = keycloak
Vue.prototype.$user = null


function updateHeaders () {
  const authHeaders = new Headers()
  authHeaders.append('Authorization', `Bearer ${keycloak.token}`)
  const postHeaders = new Headers()
  postHeaders.append('Authorization', `Bearer ${keycloak.token}`)
  //postHeaders.append('Accept', 'application/json')
  postHeaders.append('Content-Type', 'application/json')
  const postFormDataHeaders = new Headers()
  postFormDataHeaders.append('Authorization', `Bearer ${keycloak.token}`)
  Vue.prototype.$authHeaders = authHeaders
  Vue.prototype.$postHeaders = postHeaders
  Vue.prototype.$postFormDataHeaders = postFormDataHeaders
}

keycloak.init({ onLoad: initOptions.onLoad }).then(async (auth) => {
  if(auth) {
    api.token = keycloak.token
    updateHeaders()
    // чтобы keycloak отдавал роли, нужно для клиента настроить mappers
    let role,
        name = keycloak.idTokenParsed.name,
        username = keycloak.idTokenParsed.preferred_username,
        subroles = keycloak.realmAccess.roles
    if (keycloak.realmAccess.roles.includes('ROLE_ADMIN')) {
      role = 'ROLE_ADMIN'
    } else if (keycloak.realmAccess.roles.includes('ROLE_VNII')) {
      role = 'ROLE_VNII'
    }

    //формирование атрибутов юзера
    Vue.prototype.$user = {
      username: username,
      name: name,
      role: role,
      subroles: subroles,
    }
    console.log(Vue.prototype.$user)

    // Token Refresh
    setInterval(() => {
      keycloak.updateToken(70).then((refreshed) => {
        if (refreshed) {
          api.token = keycloak.token;
        } else {
          // console.log('Token not refreshed, valid for ' + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
        }
      }).catch(() => {
        console.log('Failed to refresh token')
      })
    }, 6000)
  }


  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    render: h => h(App, {props: {keycloak: keycloak}}),
    vuetify,
    router
  })
}).catch((e) => {
  console.log('Authentication Failed: ' + e)
})

function clean (obj) {
  for (let propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName]
    }
  }
  return obj
}

async function downloadFie (fileName, url, method, headers, body) {
  let req = await fetch(url.toString(), {method: method, headers: headers, body: body})
  if (!req.ok) {
    alert('Ошибка скачивания файла!')
    console.log(req)
  }
  let urln = URL.createObjectURL(await req.blob())
  const a = document.createElement('a')
  a.download = fileName
  a.style.display = 'none'
  a.href = urln
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(urln)
}

Vue.prototype.$downloadApi = async function(fileName, path, querySpec, isJsonBody) {
  if (path[0] !== '/') {
    path = '/' + path
  }
  const url = new URL(this.$backendUrl + path)
  if(isJsonBody === true) {
    await downloadFie(fileName, url.toString(), "POST", this.$postHeaders, JSON.stringify(querySpec))
  } else {
    if (querySpec != null) {
      url.search = new URLSearchParams(clean(querySpec)).toString()
    }
    await downloadFie(fileName, url, "GET", this.$authHeaders)
  }
}
